import React from 'react'
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'

import './style.css'
import Contact from './views/contact'
import RFQPortal from './views/rfq-portal'
import DumpsterRental from './views/dumpster-rental'
import Home from './views/home'
import AboutUs from './views/about-us'
import Services from './views/services'
import NotFound from './views/not-found'

const App = () => {
  return (
    <Router>
      <Switch>
        <Route component={Contact} exact path="/contact" />
        <Route component={RFQPortal} exact path="/rfq-portal" />
        <Route component={DumpsterRental} exact path="/dumpster-rental" />
        <Route component={Home} exact path="/" />
        <Route component={AboutUs} exact path="/about-us" />
        <Route component={Services} exact path="/services" />
        <Route component={NotFound} path="**" />
        <Redirect to="**" />
      </Switch>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
